import { render, staticRenderFns } from "./NewOffer.vue?vue&type=template&id=4e84a1a8&"
import script from "./NewOffer.vue?vue&type=script&lang=ts&"
export * from "./NewOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports